export const previewGameData = {
  "access": [
    "points",
    "leaderboards",
    "levels",
    "badges",
    "challenges",
    "secretCodes",
    "currency",
    "marketplace",
    "items",
    "prizepacks",
    "collections",
    "store"
  ],
  "bg": {
    "url": "https://app.gamably.com//images/themes/2025/roman_bg.jpg",
    "type": "image"
  },
  "border_header": "primary",
  "border_icon": "none",
  "color": "#6b4820",
  "createdBadges": 8,
  "createdChallenges": 10,
  "createdCollections": 2,
  "createdElementTotal": 69,
  "createdItems": 31,
  "createdLeaderboards": 3,
  "createdLevels": 5,
  "createdPrizePacks": 1,
  "createdSecretCodes": 6,
  "createdTeams": 3,
  "creatorId": "aNapmyU75jGnponX7NyizAmjq4uZ",
  "creatorName": "Testy McTester",
  "desc": `<p>This Gamably Preview Game is designed to showcase our features and functionality including:</p>
    <ul>
    <li>Points</li>
    <li>Leaderboards</li>
    <li>Levels</li>
    <li>Badges</li>
    <li>Challenges</li>
    <li>Secret Codes</li>
    <li>Items</li>
    <li>The Item Marketplace</li>    
    <li>Prize Packs</li>
    <li>Collections</li>
    <li>And More!</li>
    </ul>`,
  "enroll_upload": true,
  "gameId": "previewgame",
  "gameName": "Gamably Preview Game",
  "header": "/images/themes/2025/roman_head.jpg",
  "icon": "/images/themes/2025/roman_icon.jpg",
  "joinCode": "gamably-preview",
  "path": "previewgame",
  "playerCount": 25,
  "shortDesc": "The Gamably Preview: A Test Game for Exploring Our Features!",
  "sortLeaders": "points",
  "status": "active",
  "ts": 1770155494770,
  "ts_created": 1730324415923,
}

export const previewGameStats = {
  "1772230537889-86781-LNymX-item_earned": 2,
  "1772569770551-86781-LNymX-challenge_declined": 1,
  "1772590997526-86781-LNymX-prizepack_earned": 11,
  "1772230537881-86781-LNymX-item_purchased": 1,
  "currency_earned": 5450,
  "1772572118651-86781-LNymX-challenge_submitted": 1,
  "1772595348386-86781-LNymX-secretCode_earned": 1,
  "1772230537871-86781-LNymX-item_purchased": 2,
  "1772230537885-86781-LNymX-item_earned": 1,
  "1772230537869-86781-LNymX-item_purchased": 1,
  "1772230537869-86781-LNymX-item_earned": 1,
  "1772595348387-86781-LNymX-secretCode_earned": 1,
  "1772572118651-86781-LNymX-challenge_approved": 1,
  "1772230537881-86781-LNymX-item_earned": 1,
  "1772590648474-86781-LNymX-level_earned": 6,
  "ts": 1774663210148,
  "1772230537882-86781-LNymX-item_purchased": 1,
  "1772230537890-86781-LNymX-item_earned": 3,
  "1772230537866-86781-LNymX-item_earned": 7,
  "1772569886040-86781-LNymX-challenge_approved": 1,
  "1772230537888-86781-LNymX-item_earned": 4,
  "1772230537874-86781-LNymX-item_earned": 1,
  "1772569834612-86781-LNymX-challenge_approved": 1,
  "1772595348385-86781-LNymX-secretCode_earned": 1,
  "1772595348384-86781-LNymX-secretCode_earned": 1,
  "1772230537874-86781-LNymX-item_purchased": 1,
  "1772230537875-86781-LNymX-item_earned": 3,
  "1772230537891-86781-LNymX-item_earned": 2,
  "1772230537885-86781-LNymX-item_purchased": 1,
  "1772230537871-86781-LNymX-item_submitted": 1,
  "1772595348383-86781-LNymX-secretCode_earned": 1,
  "1772569886040-86781-LNymX-challenge_submitted": 2,
  "1772569834612-86781-LNymX-challenge_submitted": 1,
  "1772569770551-86781-LNymX-challenge_approved": 2,
  "1772230537882-86781-LNymX-item_earned": 1,
  "1772230537887-86781-LNymX-item_earned": 1,
  "1772569770551-86781-LNymX-challenge_submitted": 3,
  "1772590711756-86781-LNymX-level_earned": 1,
  "1772230537868-86781-LNymX-item_earned": 5,
  "1772230537870-86781-LNymX-item_earned": 4,
  "1772230537871-86781-LNymX-item_earned": 2,
  "points_earned": 1280
}

export const previewGameMessages = {
  "1761228182799_80495-LNymX_message": {
    "ts_created": 1761228182799,
    "gameId": "1760127880495-LNymXRI-game",
    "message": "Welcome, young citizens, to our Roman Empire classroom, where learning is an epic journey! Throughout the year, you'll earn Denarii for your valiant efforts and scholarly achievements, just like ancient Romans. These coins can then be spent at the Roman Market, purchasing unique benefits and privileges that enhance your experience in our empire. Strive for greatness, contribute to our community, and rise through the ranks to become esteemed Roman citizens!",
    "title": "Welcome to the Roman Adventure!",
    "ts": 1761228182799,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "id": "1761228182799_80495-LNymX_message"
  }
}

export const previewRewardPresets = {}

export const previewUserContent = {
  "currentUser": {
    "displayName": "Testy McTester",
    "email": "preview@gamably.com",
    "metadata": {
      "createdAt": new Date().getTime(),
    },
    "photoURL": "https://gamably.com/images/themes/2025/gamably_icon.png",
    "provider": "preview",
    "uid": "preview-manager"
  },
  "membership": {
    "appId": "preview-manager",
    "email": "preview@gamably.com",
    "membership": 3,
    "ts": new Date().getTime(),
    "ts_expires": 0
  },
  "userProfile": {
    "admin": false,
    "appId": "preview-manager",
    "birthday": 21600000,
    "email": "preview@gamably.com",
    "fName": "Testy",
    "gamesCreated": [],
    "gradient": "linear-gradient(to left, #c1745f, #81b165)",
    "icon": "https://app.gamably.com/images/themes/2025/gamably_icon.png",
    "lName": "McTester",
    "legalApproved": new Date().getTime(),
    "name": "Testy McTester",
    "purpose": "Business",
    "status": "active",
    "stripeCustomerId": "preview-manager",
    "ts_created": new Date().getTime(),
    "ts_joined": new Date().getTime(),
    "ts": new Date().getTime(),
    "uid": "preview-manager"
  }
}

export const previewPlayerUserProfiles = {
  "2uiwtc_w9wo88dhqj9": {
    "appId": "OKBBAo2RM44OS9DjaPrHxwrU",
    "fName": "Elara",
    "gamePath": "msmf47drmoxrd28",
    "gradient": "linear-gradient(to right, #99064e, #6e8490)",
    "icon": null,
    "legalApproved": 1774497543178,
    "lName": "Frost",
    "name": "Elara Frost",
    "status": "active",
    "ts": 1772202099979,
    "ts_joined": 1772202099979,
    "uid": 'preview-player',
    "upload": true
  },
  "0cq39ufq8-sigmeb3y": {
    "appId": "YF29Cw25nRFWUe6t37OtFiwm",
    "fName": "Leo",
    "gamePath": "msmf47drmoxrd28",
    "gradient": "linear-gradient(to left, #d8be5d, #36ef15)",
    "icon": null,
    "legalApproved": 1774988187261,
    "lName": "Maxwell",
    "name": "Leo Maxwell",
    "status": "active",
    "ts": 1772202099979,
    "ts_joined": 1772202099979,
    "uid": 'preview-player',
    "upload": true
  },
  "s_zzkdwuk_iqor5b7d": {
    "appId": "oVnAPXEE9kyQjHUCnMyZ22Bx",
    "fName": "Hazel",
    "gamePath": "msmf47drmoxrd28",
    "gradient": "linear-gradient(to top, #e811cb, #1a7c54)",
    "icon": null,
    "legalApproved": 1774988360284,
    "lName": "Thorne",
    "name": "Hazel Thorne",
    "status": "active",
    "ts": 1774988337753,
    "ts_joined": 1772202099979,
    "uid": 'preview-player',
    "upload": true
  }
}

export const previewPlayerCurrentUsers = {
  "2uiwtc_w9wo88dhqj9": {
    "displayName": "Elara F",
    "email": "OKBBAo2RM44OS9DjaPrHxwrU@gamablyplayers.com",
    "metadata": {
      "createdAt": 1774497537199,
      "lastLogInAt": null
    },
    "uid": 'preview-player',
    "photoURL": null,
    "provider": "FirestoreAuth"
  },
  "0cq39ufq8-sigmeb3y": {
    "displayName": "Leo M",
    "email": "YF29Cw25nRFWUe6t37OtFiwm@gamablyplayers.com",
    "metadata": {
      "createdAt": 1774988185000,
      "lastLogInAt": null
    },
    "uid": 'preview-player',
    "photoURL": null,
    "provider": "FirestoreAuth"
  },
  "s_zzkdwuk_iqor5b7d": {
    "displayName": "Hazel T",
    "email": "oVnAPXEE9kyQjHUCnMyZ22Bx@gamablyplayers.com",
    "metadata": {
      "createdAt": 1774988356590,
      "lastLogInAt": null
    },
    "uid": 'preview-player',
    "photoURL": null,
    "provider": "FirestoreAuth"
  }
}